<template>
  <b-card-code>
    <b-row>
      <b-col sm="6">
        <b-button-group>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :disabled="loading"
            @click="download(rows)"
          >
            Exportar a Excel
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            to="mortgage-range-add"
          >
            Agregar
          </b-button>
        </b-button-group>
      </b-col>
      <b-col sm="4">
        <!-- search input -->
        <div class="custom-search d-flex justify-content-end">
          <b-form-group>
            <b-form-input
              v-model="searchTerm"
              placeholder="Buscar"
              type="text"
              class="d-inline-block"
              @keyup.enter="search(rows, searchTerm)"
            />
          </b-form-group>
        </div>
      </b-col>
      <b-col sm="2">
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          :disabled="loading || searching"
          @click="search(rows, searchTerm)"
        >
          <span v-if="!searching">Buscar</span>
          <span v-if="searching">Buscanado...</span>
        </b-button>
      </b-col>

    </b-row>
    <b-row>
      <b-col>
        <p>Mostrando: {{ rowsFiltered.length }} de {{ rows.length }}</p>
      </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :is-loading="loading"
      :rows="rowsFiltered"
      :rtl="direction"
      :fixed-header="true"
      max-height="500px"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <div
        slot="emptystate"
        class="text-center"
      >
        No se encontraron datos
      </div>
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'fullName'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.fullName }}</span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">

          <b-button-group>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="remove(props.row.id)"
            >
              Borrar
            </b-button>
          </b-button-group>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Mostrando 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10','25', '50', '100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> de {{ props.total }} registros </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  </b-card-code>
</template>

<script>
import {
  BAvatar, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol,
  BButton, BButtonGroup,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { downloadExcel } from '@core/utils/utils'
import store from '@/store/index'
import environment from '@/environment'
import ToastificationContent from "@core/components/toastification/ToastificationContent"

export default {
  name: 'CentersTypesVue',
  components: {
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BCardCode,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: true,
      searching: false,
      pageLength: 100,
      dir: false,
      columns: [
        {
          label: 'Nº Cuenta Legal',
          field: 'cuentaLegales',
        },
        {
          label: 'Nº Cuenta Minuta',
          field: 'cuentaMinutas',
        },
        {
          label: 'ID Producto',
          field: 'idProducto',
        },
        {
          label: 'Producto',
          field: 'producto',
        },
        {
          label: 'Límite Inferior',
          field: 'limiteInferior',
          formatFn: this.currency,
        },
        {
          label: 'Límite Superior',
          field: 'limiteSuperior',
          formatFn: this.currency,
        },
        {
          label: 'Monto Legales',
          field: 'montoLegales',
          formatFn: this.currency,
        },
        {
          label: 'Monto Minutas',
          field: 'montoMinutas',
          formatFn: this.currency,
        },
        {
          label: '',
          field: 'action',
        },
      ],
      rows: [],
      rowsFiltered: [],
      searchTerm: '',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const resp = await this.$http.get(`${environment.uri}/accounts/range/idProducto/0`)

        if (resp && resp.data) {
          this.rows = resp.data.sort((a, b) => ((a.idProducto > b.idProducto) ? 1 : -1))
          this.rowsFiltered = this.rows.slice(0, 100)
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    async remove(id) {
      this.loading = true
      try {
        await this.$http.delete(`${environment.uri}/accounts/range/id/${id}`)

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Borrado',
            icon: 'CoffeeIcon',
            variant: 'Info',
          },
        })

        await this.load()
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    currency(value) {
      return `$${this.$options.filters.currency(value)}`
    },
    download(rows) {
      const items = rows.map(item => ({
        cuentaLegales: item.cuentaLegales || '',
        cuentaMinutas: item.cuentaMinutas || '',
        idProducto: item.idProducto || '',
        producto: (item.producto || '').replace(/,/g, ' '),
        limiteInferior: item.limiteInferior || '',
        limiteSuperior: item.limiteSuperior || '',
        montoLegales: item.montoLegales || '',
        montoMinutas: item.montoMinutas || '',
      }))
      downloadExcel(items, [
        'Nº Cuenta Legal',
        'Nº Cuenta Minuta',
        'ID Producto',
        'Producto',
        'Limite Inferior',
        'Limite Superior',
        'Monto Legales',
        'Monto Minutas',
      ], 'mortgage-range-report.csv')
    },
    search(arr, searchKey) {
      this.searching = true
      if (searchKey) {
        this.rowsFiltered = arr.filter(obj => Object.keys(obj).some(key => String(obj[key]).toLowerCase().includes(searchKey.toLowerCase())))
      } else {
        this.rowsFiltered = this.rows.slice(0, 100)
      }
      this.searching = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
